var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.608,
    height: 49.233,
    viewBox: "0 0 17.608 49.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-i-2490657",
    transform: "translate(-41.196 -24.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M50,32.8a3.981,3.981,0,1,0-3.981-3.981A3.981,3.981,0,0,0,50,32.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M57.043,69.25c-1.378-.442-3.062-1.737-3.062-5.431V39.569a.656.656,0,0,0-.656-.656H43.66A2.464,2.464,0,0,0,41.2,41.377a2.49,2.49,0,0,0,1.761,2.36c1.378.442,3.061,1.737,3.061,5.431V63.819c0,3.694-.812,10.254.549,10.254H56.34A2.464,2.464,0,0,0,58.8,71.609,2.49,2.49,0,0,0,57.043,69.25Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/Information.40fb8cdc4e332764c6d1a68b281c11a6.svg";
export { ForwardRef as ReactComponent };